import { executeRequest, Request } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const bulkOnboardingDeleteFile = (fileId: number, type: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: getUrl(APIEndPoints.bulkOnboardDeleteFile),
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      fileId: fileId,
      type:
        type === 'bulkUpload'
          ? 'CREATE'
          : type === 'bulkConfig'
          ? 'BULK_CONFIG'
          : type === 'bulkCard'
          ? 'BULK_CARD_CONFIG'
          : type === 'bulkVpa'
          ? 'BULK_VPA'
          : type === 'bulkStore'
          ? 'BULK_STORE'
          : type === 'bulkTerminal'
          ? 'BULK_TERMINAL'
          : type === 'MCC_EXPORT'
          ? 'BULK_MCC_OPS'
          : type === 'IFSC_EXPORT'
          ? 'BULK_IFSC_OPS'
          : type === 'PINCODE_EXPORT'
          ? 'BULK_PINCODE_OPS'
          : type === 'PROGRAM_CATEGORY_EXPORT'
          ? 'BULK_PROGRAM_CATEGORY_OPS'
          : type === 'BULK_STORE_UPDATE'
          ? 'BULK_STORE_UPDATE'
          : type === 'BULK_DEVICES'
          ? 'BULK_DEVICES'
          : type === 'BULK_TERMINAL_UPDATE'
          ? 'BULK_TERMINAL_UPDATE'
          : 'SYNC',
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { bulkOnboardingDeleteFile }
